<div class="reveal-modal-bg" style="display: block"></div>
<div
  class="reveal-modal rs-reveal-modal-loading open"
  role="alert"
  style="visibility: visible"
>
  <div
    class="rs-spinner-neg"
    aria-live="polite"
    [attr.aria-label]="message"
    aria-busy="true"
  ></div>
  <div class="rs-modal-content">
    {{ message }}
  </div>
</div>
